@if (manuallySelected()) {
  <span class="flex shrink-0 items-center gap-1 text-amber-600">
    <mat-icon
      class="icon-size-5"
      aria-hidden="false"
      [attr.aria-label]="'MANUAL_LABEL_SELECTION_INDICATOR.TEXT' | t"
      [matTooltip]="'MANUAL_LABEL_SELECTION_INDICATOR.TEXT' | t"
      [matTooltipDisabled]="showText()"
    >
      touch_app
    </mat-icon>
    @if (showText()) {
      <span class="text-xs font-medium">{{ 'MANUAL_LABEL_SELECTION_INDICATOR.TEXT' | t }}</span>
    }
  </span>
}
